// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ProviderCollectionInvoiceDiscount,
    ProviderCollectionInvoiceDiscountFromJSON,
    ProviderCollectionInvoiceDiscountToJSON,
    ProviderCollectionInvoiceGuarantor,
    ProviderCollectionInvoiceGuarantorFromJSON,
    ProviderCollectionInvoiceGuarantorToJSON,
    ProviderCollectionInvoiceLineItem,
    ProviderCollectionInvoiceLineItemFromJSON,
    ProviderCollectionInvoiceLineItemToJSON,
    ProviderCollectionInvoicePatient,
    ProviderCollectionInvoicePatientFromJSON,
    ProviderCollectionInvoicePatientToJSON,
    ProviderCollectionInvoicePayment,
    ProviderCollectionInvoicePaymentFromJSON,
    ProviderCollectionInvoicePaymentToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCollectionInvoice
 */
export interface ProviderCollectionInvoice {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    collectionInvoiceId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    controlNumber?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoice
     */
    serviceDate?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoice
     */
    invoiceAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoice
     */
    patientPayments?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoice
     */
    patientDiscounts?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoice
     */
    currentBalance?: Amount;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    renderingProviderFirstName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    renderingProviderLastName?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderCollectionInvoice
     */
    selfPay?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    facilityName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    externalFacilityId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    primaryPayerName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    primaryInsurancePlanName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    primaryInsuranceMemberId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    secondaryPayerName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    secondaryInsurancePlanName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    secondaryInsuranceMemberId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    tertiaryPayerName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    tertiaryInsurancePlanName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    tertiaryInsuranceMemberId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    memoNotes?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoice
     */
    postDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoice
     */
    retractDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    retractedByBankUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoice
     */
    approveDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    approvedByBankUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    collectionInvoiceIntegrationId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    collectionInvoiceDraftId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoice
     */
    declineDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    declinedByBankUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    declineNotes?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    claimId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoice
     */
    claimBundleId?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderCollectionInvoice
     */
    active?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoice
     */
    createDate?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoiceLineItem>}
     * @memberof ProviderCollectionInvoice
     */
    invoiceItems?: Array<ProviderCollectionInvoiceLineItem>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoiceDiscount>}
     * @memberof ProviderCollectionInvoice
     */
    discounts?: Array<ProviderCollectionInvoiceDiscount>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoicePayment>}
     * @memberof ProviderCollectionInvoice
     */
    payments?: Array<ProviderCollectionInvoicePayment>;
    /**
     * 
     * OpenAPI data type: {ProviderCollectionInvoicePatient}
     * @type {ProviderCollectionInvoicePatient}
     * @memberof ProviderCollectionInvoice
     */
    invoicePatient?: ProviderCollectionInvoicePatient;
    /**
     * 
     * OpenAPI data type: {ProviderCollectionInvoiceGuarantor}
     * @type {ProviderCollectionInvoiceGuarantor}
     * @memberof ProviderCollectionInvoice
     */
    invoiceGuarantor?: ProviderCollectionInvoiceGuarantor;
}

export function ProviderCollectionInvoiceFromJSON(json: any): ProviderCollectionInvoice {
    return {
            'collectionInvoiceId': !exists(json, 'collectionInvoiceId') ? undefined : json['collectionInvoiceId'],
            'controlNumber': !exists(json, 'controlNumber') ? undefined : json['controlNumber'],
            'serviceDate': !exists(json, 'serviceDate') ? undefined : json['serviceDate'],
            'invoiceAmount': !exists(json, 'invoiceAmount') ? undefined : AmountFromJSON(json['invoiceAmount']),
            'patientPayments': !exists(json, 'patientPayments') ? undefined : AmountFromJSON(json['patientPayments']),
            'patientDiscounts': !exists(json, 'patientDiscounts') ? undefined : AmountFromJSON(json['patientDiscounts']),
            'currentBalance': !exists(json, 'currentBalance') ? undefined : AmountFromJSON(json['currentBalance']),
            'renderingProviderFirstName': !exists(json, 'renderingProviderFirstName') ? undefined : json['renderingProviderFirstName'],
            'renderingProviderLastName': !exists(json, 'renderingProviderLastName') ? undefined : json['renderingProviderLastName'],
            'selfPay': !exists(json, 'selfPay') ? undefined : json['selfPay'],
            'facilityName': !exists(json, 'facilityName') ? undefined : json['facilityName'],
            'externalFacilityId': !exists(json, 'externalFacilityId') ? undefined : json['externalFacilityId'],
            'primaryPayerName': !exists(json, 'primaryPayerName') ? undefined : json['primaryPayerName'],
            'primaryInsurancePlanName': !exists(json, 'primaryInsurancePlanName') ? undefined : json['primaryInsurancePlanName'],
            'primaryInsuranceMemberId': !exists(json, 'primaryInsuranceMemberId') ? undefined : json['primaryInsuranceMemberId'],
            'secondaryPayerName': !exists(json, 'secondaryPayerName') ? undefined : json['secondaryPayerName'],
            'secondaryInsurancePlanName': !exists(json, 'secondaryInsurancePlanName') ? undefined : json['secondaryInsurancePlanName'],
            'secondaryInsuranceMemberId': !exists(json, 'secondaryInsuranceMemberId') ? undefined : json['secondaryInsuranceMemberId'],
            'tertiaryPayerName': !exists(json, 'tertiaryPayerName') ? undefined : json['tertiaryPayerName'],
            'tertiaryInsurancePlanName': !exists(json, 'tertiaryInsurancePlanName') ? undefined : json['tertiaryInsurancePlanName'],
            'tertiaryInsuranceMemberId': !exists(json, 'tertiaryInsuranceMemberId') ? undefined : json['tertiaryInsuranceMemberId'],
            'memoNotes': !exists(json, 'memoNotes') ? undefined : json['memoNotes'],
            'postDate': !exists(json, 'postDate') ? undefined : json['postDate'],
            'retractDate': !exists(json, 'retractDate') ? undefined : json['retractDate'],
            'retractedByBankUserId': !exists(json, 'retractedByBankUserId') ? undefined : json['retractedByBankUserId'],
            'approveDate': !exists(json, 'approveDate') ? undefined : json['approveDate'],
            'approvedByBankUserId': !exists(json, 'approvedByBankUserId') ? undefined : json['approvedByBankUserId'],
            'collectionInvoiceIntegrationId': !exists(json, 'collectionInvoiceIntegrationId') ? undefined : json['collectionInvoiceIntegrationId'],
            'collectionInvoiceDraftId': !exists(json, 'collectionInvoiceDraftId') ? undefined : json['collectionInvoiceDraftId'],
            'declineDate': !exists(json, 'declineDate') ? undefined : json['declineDate'],
            'declinedByBankUserId': !exists(json, 'declinedByBankUserId') ? undefined : json['declinedByBankUserId'],
            'declineNotes': !exists(json, 'declineNotes') ? undefined : json['declineNotes'],
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'claimBundleId': !exists(json, 'claimBundleId') ? undefined : json['claimBundleId'],
            'active': !exists(json, 'active') ? undefined : json['active'],
            'createDate': !exists(json, 'createDate') ? undefined : json['createDate'],
            'invoiceItems': !exists(json, 'invoiceItems') ? undefined : (json['invoiceItems'] as Array<any>).map(ProviderCollectionInvoiceLineItemFromJSON),
            'discounts': !exists(json, 'discounts') ? undefined : (json['discounts'] as Array<any>).map(ProviderCollectionInvoiceDiscountFromJSON),
            'payments': !exists(json, 'payments') ? undefined : (json['payments'] as Array<any>).map(ProviderCollectionInvoicePaymentFromJSON),
            'invoicePatient': !exists(json, 'invoicePatient') ? undefined : ProviderCollectionInvoicePatientFromJSON(json['invoicePatient']),
            'invoiceGuarantor': !exists(json, 'invoiceGuarantor') ? undefined : ProviderCollectionInvoiceGuarantorFromJSON(json['invoiceGuarantor']),
    };

}

export function ProviderCollectionInvoiceToForm(value?: ProviderCollectionInvoice): any {
    let jsonVal = ProviderCollectionInvoiceToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderCollectionInvoiceToJSON(value?: ProviderCollectionInvoice): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'collectionInvoiceId': cleanupBlankValuesForBackend(value.collectionInvoiceId),
            'controlNumber': cleanupBlankValuesForBackend(value.controlNumber),
            'serviceDate': cleanupBlankValuesForBackend(value.serviceDate),
            'invoiceAmount': AmountToJSON(value.invoiceAmount),
            'patientPayments': AmountToJSON(value.patientPayments),
            'patientDiscounts': AmountToJSON(value.patientDiscounts),
            'currentBalance': AmountToJSON(value.currentBalance),
            'renderingProviderFirstName': cleanupBlankValuesForBackend(value.renderingProviderFirstName),
            'renderingProviderLastName': cleanupBlankValuesForBackend(value.renderingProviderLastName),
            'selfPay': cleanupBlankValuesForBackend(value.selfPay),
            'facilityName': cleanupBlankValuesForBackend(value.facilityName),
            'externalFacilityId': cleanupBlankValuesForBackend(value.externalFacilityId),
            'primaryPayerName': cleanupBlankValuesForBackend(value.primaryPayerName),
            'primaryInsurancePlanName': cleanupBlankValuesForBackend(value.primaryInsurancePlanName),
            'primaryInsuranceMemberId': cleanupBlankValuesForBackend(value.primaryInsuranceMemberId),
            'secondaryPayerName': cleanupBlankValuesForBackend(value.secondaryPayerName),
            'secondaryInsurancePlanName': cleanupBlankValuesForBackend(value.secondaryInsurancePlanName),
            'secondaryInsuranceMemberId': cleanupBlankValuesForBackend(value.secondaryInsuranceMemberId),
            'tertiaryPayerName': cleanupBlankValuesForBackend(value.tertiaryPayerName),
            'tertiaryInsurancePlanName': cleanupBlankValuesForBackend(value.tertiaryInsurancePlanName),
            'tertiaryInsuranceMemberId': cleanupBlankValuesForBackend(value.tertiaryInsuranceMemberId),
            'memoNotes': cleanupBlankValuesForBackend(value.memoNotes),
            'postDate': cleanupBlankValuesForBackend(value.postDate),
            'retractDate': cleanupBlankValuesForBackend(value.retractDate),
            'retractedByBankUserId': cleanupBlankValuesForBackend(value.retractedByBankUserId),
            'approveDate': cleanupBlankValuesForBackend(value.approveDate),
            'approvedByBankUserId': cleanupBlankValuesForBackend(value.approvedByBankUserId),
            'collectionInvoiceIntegrationId': cleanupBlankValuesForBackend(value.collectionInvoiceIntegrationId),
            'collectionInvoiceDraftId': cleanupBlankValuesForBackend(value.collectionInvoiceDraftId),
            'declineDate': cleanupBlankValuesForBackend(value.declineDate),
            'declinedByBankUserId': cleanupBlankValuesForBackend(value.declinedByBankUserId),
            'declineNotes': cleanupBlankValuesForBackend(value.declineNotes),
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'claimBundleId': cleanupBlankValuesForBackend(value.claimBundleId),
            'active': cleanupBlankValuesForBackend(value.active),
            'createDate': cleanupBlankValuesForBackend(value.createDate),
            'invoiceItems': (value.invoiceItems === undefined || value.invoiceItems === null) ? undefined : (value.invoiceItems as Array<any>).map(ProviderCollectionInvoiceLineItemToJSON),
            'discounts': (value.discounts === undefined || value.discounts === null) ? undefined : (value.discounts as Array<any>).map(ProviderCollectionInvoiceDiscountToJSON),
            'payments': (value.payments === undefined || value.payments === null) ? undefined : (value.payments as Array<any>).map(ProviderCollectionInvoicePaymentToJSON),
            'invoicePatient': ProviderCollectionInvoicePatientToJSON(value.invoicePatient),
            'invoiceGuarantor': ProviderCollectionInvoiceGuarantorToJSON(value.invoiceGuarantor),
    };
}


